import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=1689eafe&scoped=true"
import script from "./Box.vue?vue&type=script&lang=js"
export * from "./Box.vue?vue&type=script&lang=js"
import style0 from "./Box.vue?vue&type=style&index=0&id=1689eafe&prod&lang=less"
import style1 from "./Box.vue?vue&type=style&index=1&id=1689eafe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1689eafe",
  null
  
)

export default component.exports